import { EnumOptionsList } from "@/types/common";
import { ComplinEnum, ExistEnum, InspectionOrderStatus } from "@/types/inspection";
import { SpecialHandlingStateEnum } from "@/types/inventoryV2";
import { useTranslation } from "react-i18next";

const useInspactionEnum = (addVn = true) => {
  const { t } = useTranslation();

  const InspectionStatusEnums: EnumOptionsList<InspectionOrderStatus>[] = [
    {
      key: InspectionOrderStatus.DRAFT,
      value: InspectionOrderStatus.DRAFT,
      color: "cyan",
      label: addVn ? `${t('inspection.draft', { lng: "zh" })}/${t('inspection.draft', { lng: "vn" })}` : t('inspection.draft')
    },
    {
      key: InspectionOrderStatus.PENDING,
      value: InspectionOrderStatus.PENDING,
      color: "geekblue",
      label: addVn ? `${t('inspection.pending', { lng: "zh" })}/${t('inspection.pending', { lng: "vn" })}` : t('inspection.pending')
    },
    {
      key: InspectionOrderStatus.RESOLVED,
      value: InspectionOrderStatus.RESOLVED,
      color: "green",
      label: addVn ? `${t('inspection.resolved', { lng: "zh" })}/${t('inspection.resolved', { lng: "vn" })}` : t('inspection.resolved')
    },
    {
      key: InspectionOrderStatus.REJECTED,
      value: InspectionOrderStatus.REJECTED,
      color: "red",
      label: addVn ? `${t('inspection.rejected', { lng: "zh" })}/${t('inspection.rejected', { lng: "vn" })}` : t('inspection.rejected')
    },
  ];

  const getInspectionStatus = (value: InspectionOrderStatus | null) => {
    if (value === null) return
    return InspectionStatusEnums.find(i => i.value === value)
  };

  const ExistEnumList: EnumOptionsList<ExistEnum>[] = [
    {
      key: ExistEnum.NOT,
      value: ExistEnum.NOT,
      color: "red",
      label: addVn ? `${t('inspection.notE', { lng: "zh" })}/${t('inspection.notE', { lng: "vn" })}` : t('inspection.notE')
    },
    {
      key: ExistEnum.YES,
      value: ExistEnum.YES,
      color: "green",
      label: addVn ? `${t('inspection.exist', { lng: "zh" })}/${t('inspection.exist', { lng: "vn" })}` : t('inspection.exist')
    },
    {
      key: ExistEnum.PART,
      value: ExistEnum.PART,
      color: "cyan",
      label: addVn ? `${t('inspection.partE', { lng: "zh" })}/${t('inspection.partE', { lng: "vn" })}` : t('inspection.partE')
    },
  ];

  const getExistEnum = (value: ExistEnum | null) => {
    if (value === null) return {
      color: "geekblue",
      label: addVn ? `${t('inspection.notInspect', { lng: "zh" })}/${t('inspection.notInspect', { lng: "vn" })}` : t('inspection.notInspect')
    }
    return ExistEnumList.find(i => i.value === value)
  };

  const ComplinEnumList: EnumOptionsList<ComplinEnum>[] = [
    {
      key: ComplinEnum.NOT,
      value: ComplinEnum.NOT,
      color: "red",
      label: addVn ? `${t('inspection.notS', { lng: "zh" })}/${t('inspection.notS', { lng: "vn" })}` : t('inspection.notS')
    },
    {
      key: ComplinEnum.YES,
      value: ComplinEnum.YES,
      color: "green",
      label: addVn ? `${t('inspection.suitable', { lng: "zh" })}/${t('inspection.suitable', { lng: "vn" })}` : t('inspection.suitable')
    },
    {
      key: ComplinEnum.PART,
      value: ComplinEnum.PART,
      color: "cyan",
      label: addVn ? `${t('inspection.partS', { lng: "zh" })}/${t('inspection.partS', { lng: "vn" })}` : t('inspection.partS')
    },
  ];

  const getCompline = (value: ComplinEnum | null) => {
    if (value === null) return {
      color: "geekblue",
      label: addVn ? `${t('inspection.notInspect', { lng: "zh" })}/${t('inspection.notInspect', { lng: "vn" })}` : t('inspection.notInspect')
    }
    return ComplinEnumList.find(i => i.value === value)
  };

  const SpecialHandlingStateList: EnumOptionsList<SpecialHandlingStateEnum>[] = [
    {
      key: SpecialHandlingStateEnum.REJECTED,
      value: SpecialHandlingStateEnum.REJECTED,
      color: "red",
      label: addVn ? `${t('inspection.notSx', { lng: "zh" })}/${t('inspection.notSx', { lng: "vn" })}` : t('inspection.notSx')
    },
    {
      key: SpecialHandlingStateEnum.RESOLVED,
      value: SpecialHandlingStateEnum.RESOLVED,
      color: "green",
      label: addVn ? `${t('inspection.suitablex', { lng: "zh" })}/${t('inspection.suitablex', { lng: "vn" })}` : t('inspection.suitablex')
    },
    {
      key: SpecialHandlingStateEnum.PENDING,
      value: SpecialHandlingStateEnum.PENDING,
      color: "cyan",
      label: addVn ? `${t('inspection.partSx', { lng: "zh" })}/${t('inspection.partSx', { lng: "vn" })}` : t('inspection.partSx')
    },
  ];

  const getSpecialHandling = (value: SpecialHandlingStateEnum | null) => {
    if (value === null) return {
      value: null,
      color: "geekblue",
      label: addVn ? `${t('inspection.notInspectx', { lng: "zh" })}/${t('inspection.notInspectx', { lng: "vn" })}` : t('inspection.notInspectx')
    }
    return SpecialHandlingStateList.find(i => i.value === value)
  };


  return {
    InspectionStatusEnums,
    getInspectionStatus,
    ExistEnumList,
    getExistEnum,
    ComplinEnumList,
    getCompline,
    SpecialHandlingStateList,
    getSpecialHandling
  }
};

export default useInspactionEnum;